import { SearchResultPage } from './SearchResult.page';

export const searchResultRouter = {
  '/@/search': SearchResultPage,
};
